import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { router } from './router';
import { PainterlyFilters } from './components/PainterlyFilters';
import './styles/globals.css';

// A redeploy gives lazy chunks new hashes and removes the old files, so a tab
// still running an older build 404s when it imports a now-missing chunk
// ("Failed to fetch dynamically imported module") — e.g. clicking through to a
// route whose chunk it hadn't loaded yet. Vite fires `vite:preloadError` then;
// reload once to fetch the fresh index.html (and its current chunk URLs). The
// sessionStorage guard prevents a reload loop if a chunk is genuinely gone.
window.addEventListener('vite:preloadError', () => {
  const KEY = 'wrappa:chunk-reload-at';
  const now = Date.now();
  if (now - Number(sessionStorage.getItem(KEY) ?? '0') > 10_000) {
    sessionStorage.setItem(KEY, String(now));
    window.location.reload();
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <PainterlyFilters />
    <RouterProvider router={router} />
    <Toaster position="top-center" richColors closeButton />
  </StrictMode>,
);
